// extracted by mini-css-extract-plugin
export default {"content":"JoinSuccess_content__2SBJz"};